import React from 'react';
import { Link } from 'react-router-dom';
// import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { AiFillGithub } from 'react-icons/ai';
import './Footer.scss';

const Footer = () => {
    return (
        <div className="footer" id="footer">
            <h1 className="footer-header">Get daily movie updates</h1>
            {/* <ul className="footer-links">
                <li className="footer-item">
                    <Link className="footer-link">About Us</Link>
                </li>
                <li className="footer-item">
                    <Link className="footer-link">Contact</Link>
                </li>
                <li className="footer-item">
                    <Link className="footer-link">Support</Link>
                </li>
                <li className="footer-item">
                    <Link className="footer-link">Terms of use</Link>
                </li>
                <li className="footer-item">
                    <Link className="footer-link">Privacy Policy</Link>
                </li>
            </ul> */}
            {/* <div className="social-icons">
                <Link className="social-icon" to="/" target="_blank">
                    <FaFacebook />
                </Link>
                <Link className="social-icon" to="/" target="_blank">
                    <FaInstagram />
                </Link>
                <Link className="social-icon" to="/" target="_blank">
                    <FaTwitter />
                </Link>
                <Link className="social-icon" to="/" target="_blank">
                    <FaYoutube />
                </Link>
            </div> */}
            <p className="copyright">&copy; 2021. All rights reserved. 
                <span>
                    <Link to={{ pathname:"https://github.com/daviddamicodes" }} target="_blank"><AiFillGithub/> David Dami</Link>
                </span>
            </p>
        </div>
    )
}

export default Footer
